// extracted by mini-css-extract-plugin
export default {"container":"CheckInputForm_container__TERe0","label":"CheckInputForm_label__h9Xco"};